import { z } from 'zod';
import { Money } from './common';

export const AlertKind = z.enum(['target_hit', 'sharp_drop', 'near_target', 'rare_deal']);
export type AlertKind = z.infer<typeof AlertKind>;

export const AlertChannel = z.enum(['app', 'telegram']);
export type AlertChannel = z.infer<typeof AlertChannel>;

export const AlertEvent = z.object({
  id: z.string(),
  routeId: z.string(),
  kind: AlertKind,
  price: Money,
  previousPrice: Money.nullable(),
  target: Money.nullable(),
  /** % abaixo do topo da faixa típica, quando aplicável. */
  belowTypicalPct: z.number().int().nullable(),
  channels: z.array(AlertChannel),
  createdAt: z.string(),
  route: z.object({
    originCity: z.string(),
    destinationCity: z.string(),
    outboundDate: z.string(),
    returnDate: z.string().nullable(),
  }),
});
export type AlertEvent = z.infer<typeof AlertEvent>;

export const AlertList = z.object({ alerts: z.array(AlertEvent) });
export type AlertList = z.infer<typeof AlertList>;

export const TelegramStatus = z.object({
  configured: z.boolean(),
  linked: z.boolean(),
  botUsername: z.string().nullable(),
  /** Link t.me com código de vínculo válido por 30 min. Só vem quando ainda não há vínculo. */
  linkUrl: z.string().nullable(),
});
export type TelegramStatus = z.infer<typeof TelegramStatus>;
